import styled from "styled-components";

export const Cover = styled.div`
  background-size: cover;
  background-position: center center;
  border-radius: 100px;
  height: 90px;
  width: 90px;
`;

export const Container = styled.div`
  border: transparent;
`;

export const Title = styled.span`
  font-weight: bold;
  color: var(--color-gray);
  font-size: 1.3rem;
`;

export const Subtitle = styled.p`
  font-size: 0.8rem;
`;
